module.exports = __webpack_public_path__ + "img/co-neutral-logo.65b95c1.png";